"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORT_TYPE = exports.HEADER_HEIGHT = void 0;
exports.HEADER_HEIGHT = '5rem';
exports.SORT_TYPE = {
    DEFAULT: '',
    ASC: 'asc',
    DESC: 'desc',
};
